import { render, staticRenderFns } from "./credit-note-tabs.vue?vue&type=template&id=308aa99b&scoped=true&"
import script from "./credit-note-tabs.ts?vue&type=script&lang=ts&"
export * from "./credit-note-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./credit-note-tabs.scss?vue&type=style&index=0&id=308aa99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308aa99b",
  null
  
)

export default component.exports